import moment from "moment"

export const dateTimeFormatter = (unix: number) => {
  return moment(unix).format('LLL');
  // return moment(unix).format('MMMM Do, YYYY, H:m');
}